import NotificationsIcon from './component.jsx'
export default NotificationsIcon
